import { useState, useEffect } from 'react';
import api from '../services/api';

export const useZReports = ({ startDate, endDate, perPage: initialPerPage = 10 } = {}) => {
  const [reports, setReports] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [perPage, setPerPage] = useState(10);

  const fetchReports = async (page = 1) => {
    setLoading(true);
    setError(null);
    
    try {
      const params = new URLSearchParams();
      
      if (startDate) params.append('start_date', startDate);
      if (endDate) params.append('end_date', endDate);
      if (perPage) params.append('per_page', perPage.toString());
      if (page > 1) params.append('page', page.toString());

      const response = await api.get(`/zreports?${params.toString()}`);
      
      if (response.data && response.data.data) {
        setReports(response.data.data);
        setPagination(response.data.pagination);
      } else {
        setReports(response.data || []);
        setPagination(response.data?.pagination || null);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar los reportes');
      console.error('Error fetching Z reports:', err);
    } finally {
      setLoading(false);
    }
  };

  const goToPage = (page) => {
    if (pagination && page >= 1 && page <= pagination.last_page) {
      fetchReports(page);
    }
  };

  const nextPage = () => {
    if (pagination?.has_more_pages) {
      goToPage(pagination.current_page + 1);
    }
  };

  const prevPage = () => {
    if (pagination && pagination.current_page > 1) {
      goToPage(pagination.current_page - 1);
    }
  };

  const changePerPage = (newPerPage) => {
    setPerPage(newPerPage);
    fetchReports(1);
  };

  useEffect(() => {
    fetchReports();
  }, [startDate, endDate, perPage]);

  return {
    reports,
    pagination,
    loading,
    error,
    perPage,
    fetchReports,
    goToPage,
    nextPage,
    prevPage,
    changePerPage,
  };
}; 